module.exports = Jsw.skinUrl + "/icons/16/plesk/list-type-active.png?2bd72c88d60436bb8acc8328ed7f9ed3";